<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <div class="d-flex">
      <h1 class="mb-3">{{ collection.name }}</h1>
    </div>
    <p>{{collection.info}}</p>
    <b-row>
      <b-col md="3" xl="3" xxl="2">
        <ul class="nav nav-toc">
          <Section v-for="section in sections" :key="section.id" :item="section" />
        </ul>
      </b-col>
      <b-col md="9" xl="9" xxl="10">
        <div>
          <h3>{{ section.name }}</h3>
          <p>{{ section.info }}</p>
        </div>
        <div class="loader" v-if="loading">
          <b-spinner variant="primary" label="Loading..." class="align-self-center"></b-spinner>
        </div>
        <Resource v-else v-for="resource in resources" :key="resource.id" :resource="resource" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Section from "@/components/Section";
import Resource from "@/components/Resource";

export default {
  components: { Section, Resource },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs",
      collection: "resources/collection",
      sections: "resources/sections",
      project_title: "project/title",
      section: "resources/curSection",
      resources: "resources/resources"
    })
  },
  methods: {
    ...mapActions({
      fetchCollection: "resources/fetchCurCollection",
      fetchSections: "resources/fetchSections"
    })
  },
  created() {
    this.loading = true;
    this.fetchCollection(this.$route.params.uuid)
      .then()
      .catch(err => {
        console.log(err);
      });
    this.fetchSections(this.$route.params.uuid)
      .then(() => {
        this.$store.getters["resources/sections"];
      })
      .catch(err => console.log(err))
      .then(() => {
        this.loading = false;
      });

    const crumbs = [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "Resursi",
        to: { name: "resources" }
      },
      {
        text: this.collection.name,
        to: { name: "collection" },
        active: true
      }
    ];
    this.$store.commit("setBreadcrumbs", crumbs);
  }
};
</script>

<style>
</style>